import React, { useState } from "react";
import ReactDatatable from "@mkikets/react-datatable";
import { useGetAdsPointsSettingQuery } from "../../../redux/adsApi";
import { useTranslation } from "react-i18next";
import { Button } from "react-bootstrap";
import EditAdsPointsSetting from "../../partial/EditAdsPointsSetting";

function AdsPointsSetting() {
    const { t } = useTranslation();
    const { data: apiResponse, isLoading } = useGetAdsPointsSettingQuery();
    const records = apiResponse?.data || [];

    const [showEdit, setShowEdit] = useState(false);
    const [editData, setEditData] = useState({});

    const handleEdit = (record) => {
        setEditData(record);
        setShowEdit(true);
    };

    const columns = [
        {
            key: "srno.",
            text: t('sr_no') || 'Sr. No.',
            className: "sr_no.",
            align: "left",
            sortable: true,
            cell: (row, index) => index + 1,
        },
        {
            key: "ads_number",
            text: t('ads_number') || 'Ads Number',
            className: "ads_number",
            align: "left",
            sortable: true,
        },
        {
            key: "ads_point",
            text: t('ads_point') || 'Ads Point',
            className: "ads_point",
            align: "left",
            sortable: true,
        },
        {
            key: "status",
            text: t('status') || 'Status',
            className: "status",
            align: "left",
            sortable: true,
        },
        {
            key: "action",
            text: t('actions') || 'Actions',
            className: "Action",
            align: "left",
            sortable: false,
            cell: (record) => {
                return (
                    <Button variant="info" size="sm" onClick={() => handleEdit(record)}>
                        {t('edit') || 'Edit'}
                    </Button>
                );
            },
        },
    ];

    const config = {
        page_size: 10,
        length_menu: [10, 20, 50],
        filename: "AdsPointsSetting",
        no_data_text: isLoading ? t('loading') || 'Loading...' : t('no_record_found') || 'No record found!',
        language: {
            filter: t('search_in_records') || 'Search...',
            pagination: {
                first: t('first') || 'First',
                previous: t('previous') || 'Previous',
                next: t('next') || 'Next',
                last: t('last') || 'Last',
            },
        },
        show_length_menu: true,
        show_filter: true,
        show_pagination: true,
        show_info: true,
    };

    return (
        <section className="section dashboard">
            <div className="pagetitle d-flex align-items-center justify-content-between mb-4">
                <h1>{t('admob_points_setting') || 'AdMob Points Setting'}</h1>
            </div>

            <div className="card">
                <div className="card-body pt-4">
                    <ReactDatatable
                        key="datatable-ads-points-setting"
                        config={config}
                        records={records}
                        columns={columns}
                        dynamic={false}
                    />
                </div>
            </div>

            <EditAdsPointsSetting
                show={showEdit}
                onHide={() => setShowEdit(false)}
                editData={editData}
            />
        </section>
    );
}

export default AdsPointsSetting;
